import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../interseptor/axiosConf";
import ToastrNotifi from "../Utilities/ToastrNotifi";

// Function to fetch the last reads data
function fetchLastReads() {
    return axios.get(`/api/user/last/reads`).then(res => res.data);
}

// Hook to fetch the last reads list
export const useGetLastReads = () => {
    return useQuery({
        queryKey: ["LastReads"],
        queryFn: fetchLastReads,
    });
};

// Function to set a new last read
function setLastRead(page_id) {
    return axios.get(`/api/set/user/last/reads/${page_id}`).then(res => res.data);
}

// Hook to handle creating a new last read and refreshing the list
export const useUpdateLastReads = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: setLastRead,
        onSuccess: (data) => {
            if (data.success) {
                // Invalidate the last reads query to refetch updated data
                queryClient.invalidateQueries(["LastReads"]);
            } else {
                ToastrNotifi.errorToast("Something went wrong while updating last reads!");
            }
        },
    });
};
